import { z } from "zod";

export const AIRDROP_FARMING_BOT_TYPE = {
  PERP: "perp",
  SPOT: "spot",
} as const;

export const AIRDROP_FARMING_BOT_TYPE_VALUES = Object.values(AIRDROP_FARMING_BOT_TYPE);

export const AirdropFarmingBotTypeSchema = z.enum(AIRDROP_FARMING_BOT_TYPE_VALUES);
export type AirdropFarmingBotType = z.infer<typeof AirdropFarmingBotTypeSchema>;

/**
 * Bot strategy family. Used as a type-safe token when gating per-strategy
 * feature flags (e.g. `exchange_<x>_mm_enable` vs `exchange_<x>_dn_enable`) or
 * labeling metrics. Pass the enum member, never a raw `"mm"` / `"dn"` string.
 *
 * Distinct from `AIRDROP_FARMING_STRATEGY` below, which holds algorithm IDs
 * (`"depth-pulse"`, …) selected inside the MM strategy.
 */
export const AIRDROP_FARMING_BOT_STRATEGY = {
  MM: "mm",
  DN: "dn",
} as const;

export type AirdropFarmingBotStrategy =
  (typeof AIRDROP_FARMING_BOT_STRATEGY)[keyof typeof AIRDROP_FARMING_BOT_STRATEGY];

/**
 * Public-facing strategy IDs exposed to the frontend.
 * These are opaque labels — the real algorithm IDs are only known by the API.
 */
export const AIRDROP_FARMING_STRATEGY = {
  DEPTH_PULSE: "depth-pulse",
  VOLATILITY_SURFER: "volatility-surfer",
  FLOW_GUARD: "flow-guard",
  BOUNCE_CATCHER: "bounce-catcher",
  ADAPTIVE_SHIELD: "adaptive-shield",
  RAZOR_EDGE: "razor-edge",
  STORM_SWITCH: "storm-switch",
  ORACLE: "oracle",
} as const;

export const AIRDROP_FARMING_STRATEGY_VALUES = Object.values(AIRDROP_FARMING_STRATEGY);

export const AirdropFarmingStrategySchema = z.enum(AIRDROP_FARMING_STRATEGY_VALUES);
export type AirdropFarmingStrategy = z.infer<typeof AirdropFarmingStrategySchema>;
